import { ORDER_TEMP } from "../apis/cabinet";
export default {
  methods: {
    onReadMe() {
      const VUE_APP_PACT = `${process.env.VUE_APP_WEBSITE}/content/user_agreement.html`;
      window.open(VUE_APP_PACT);
    },
    agreeHandleChange() {
      console.log("Agree is checked:", this.agree_is_checked);
    },

    onSubmit() {
      if (!this.token && !this.user) {
        return this.$toast("Please grant authorization for login first.");
      }
      if (!this.cabinet) {
        return this.$toast("Please scan the code to obtain the information.");
      }
      if (!this.agree_is_checked) {
        return this.$toast("Please agree to the terms of service first.");
      }

      this.$store.commit("wallet", null);
      // userWallet 用户钱包 && yajin 押金金额  && overtimeAmount 超时金额
      const { userWallet = {}, yajin, overtimeAmount } = this.cabinet || {};
      console.log(this.cabinet, userWallet, yajin, overtimeAmount);
      const pBalance = userWallet.pBalance || 0;

      // 余额租借
      let isRentChanel =
        pBalance >= yajin && userWallet.pCurrencyType === "QAR";
      // 余额/免费 - 我的余额>押金金额>=超时金额
      if ((pBalance >= yajin && pBalance >= overtimeAmount) || isRentChanel) {
        return this.onBorrow();
      }
      // 保存卡
      var _isUserCard = this.cardList.length > 0;
      const goSaveCard = () => {
        // this.$router.push({
        //   path: "/payment_card",
        //   query: { rentSave: true }
        // });
        this.onPayment();
      };

      // 卡授权 - 押金金额 = 0 && 超时金额 > 0
      if (yajin <= 0 && overtimeAmount > 0) {
        if (!_isUserCard) return goSaveCard();
        return this.saveToRent();
      }
      // 押金金额 > 0
      if (yajin > 0) {
        // 预授权 - 押金金额 == 超时金额
        if (overtimeAmount === yajin) {
          this.goConfirmPage("PAYMENT_PROPAY");
        }
        // 预授权+卡授权 - 超时金额 > 押金金额
        if (overtimeAmount > yajin) {
          if (!_isUserCard) return goSaveCard();
          this.goConfirmPage("PAYMENT_SAVED_PROPAY");
        }
      }
    },
    onBorrow() {
      this.$loading(true);
      this.$get(
        // `${ORDER_TEMP}/${this.cabinet.qrcode}/paypal`,
        `${ORDER_TEMP}?qrcode=${this.cabinet.qrcode}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data.outTradNo) {
            this.$router.push(
              `/result?tradeNo=${resp.data.outTradNo}&shopid=${this.cabinet.shopid}`
            );
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            });
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$toast(error);
        }
      );
    },
    goConfirmPage(paymentWay) {
      // const { cabinetID = "", yajintype = "" } = this.cabinet || {};
      // this.$router.push({
      //   path: "/confirm",
      //   query: {
      //     paymentWay,
      //     payType: "YJ",
      //     price: this.amount,
      //     cabinetID: cabinetID,
      //     yaJinType: yajintype
      //   }
      // });
      this.onPayment();
    }
  }
};
